export default "__VITE_PUBLIC_ASSET__e357f8d1__"